var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 55,
    viewBox: "0 0 24 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "scroll",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9393 54.394C11.5251 54.9798 12.4749 54.9798 13.0607 54.394L22.6066 44.848C23.1924 44.2623 23.1924 43.3125 22.6066 42.7267C22.0208 42.1409 21.0711 42.1409 20.4853 42.7267L12 51.212L3.51472 42.7267C2.92893 42.1409 1.97918 42.1409 1.3934 42.7267C0.807609 43.3125 0.807609 44.2623 1.3934 44.848L10.9393 54.394ZM10.5 -7.29434e-08L10.5 53.3333L13.5 53.3333L13.5 7.29434e-08L10.5 -7.29434e-08Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/Arrow 2.40025ef286efe75ed9764711b94e9ea0.svg";
export { ForwardRef as ReactComponent };